export enum UserType {
  AUDIENCE = "AUDIENCE",
  BROADCASTER = "BROADCASTER",
  MODERATOR = "MODERATOR"
}

export type UserTypes = "AUDIENCE" | "BROADCASTER" | "MODERATOR"
export type UserTypesLetters = "a" | "b" | "m"
